module.exports = __webpack_public_path__ + "static/media/fitness-retreat-price-icon.3bae2411.svg";